import React from "react";
import {
  ForgotPassword,
  Login,
} from "@quest-finance/quest-fe-shared/dist/auth";
import { PERMISSION_IAM } from "@quest-finance/quest-fe-shared/dist/iam/constants/permissions";
import { useNavigate } from "react-router";

export const UserLogin = () => {
  const navigate = useNavigate();
  return (
    <Login
      onAuthSuccess={() => navigate("/home")}
      source={PERMISSION_IAM["ACCESS.CREDIT_PLATFORM"]}
      navigate={navigate}
    />
  );
};

export const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <ForgotPassword
      source={PERMISSION_IAM["ACCESS.CREDIT_PLATFORM"]}
      navigate={navigate}
    />
  );
};

export default UserLogin;
